import { Heading } from "components";
import strings from "locales/en";
import React from "react";
import { Link } from "react-router-dom";
import { Img } from "components";

export default function CookiePolicy() 
{

    return (
        <>
            <header
            className={`flex justify-start items-center py-6 sm:py-5 bg-white sm:items-start`}>
                <div className="flex items-center gap-[81px] px-4 md:px-5 sm:items-start sm:gap-5">
                    <Link to="/">
                    <Img
                        src="images/img_header_logo.svg"
                        alt="Headerlogo"
                        className="w-[6.4vw] ml-[5vw] md:w-[60px] object-contain sm:h-[32px] sm:w-fit"
                    />
                    </Link>
                </div>
            </header>

            <div className="w-full flex items-center justify-center bg-white mb-10">
                <div className="w-[90vw] flex flex-col items-start justify-start ">
                    <Heading as="h1" className="font-lora text-dark-blue-secondary text-[2.5vw] sm:text-[40px] md:text-[40px] font-bold mt-[16px] mb-[16px]">
                        {strings.en.cookiePolicy.title}
                    </Heading>
                    <Heading as="p" noFont={true} className="font-lora text-black-600 text-[18px]">
                        {strings.en.cookiePolicy.effectiveDate}
                    </Heading>
                    <Heading as="p" noFont={true} className="font-lora text-black-600 text-[18px]">
                        {strings.en.cookiePolicy.lastUpdated}
                    </Heading>
                    <Heading as="p" noFont={true} className="font-lora text-black-600 text-[18px] mt-[.8dvw]">
                        {strings.en.cookiePolicy.intro}
                    </Heading>
                    <div className="w-full flex flex-col items-start justify-start mt-[2vw]">
                    {strings.en.cookiePolicy.articles.map((art, index) => (
                        <div key={index} className="w-full flex flex-col mt-10 items-start justify-start">
                            <Heading
                            noFont={true}
                            as="h2"
                            className="font-lora text-black-600 text-[1.8vw] sm:text-[30px] md:text-[30px] font-bold mt-[16px] mb-[16px]"
                            >
                            {art.title}
                            </Heading>

                            {art.content.includes("<image>") ? (
                            art.content.split("<image>").map((section, i) => (
                                <div key={i} className="w-full">
                                {section.split("\n").map((line, j) => (
                                    <p key={j} className="font-lora text-black-600 text-[18px] mb-2">
                                    {line.split(/(<link\s+[^>]+>)/g).map((part, k) => {
                                        const match = part.match(/<link\s+(.*?),\s*(https?:\/\/[^>]+)>/);
                                        if (match) {
                                        const text = match[1];
                                        const url = match[2]
                                        return (
                                            
                                            <a
                                            key={k}
                                            href={url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 underline"
                                            >
                                            {text}
                                            </a>
                                        );
                                        }
                                        return <React.Fragment key={k}>{part}</React.Fragment>;
                                    })}
                                    </p>
                                ))}
                                {i !== art.content.split("<image>").length - 1 && (
                                    <img
                                    src="images/Cookie table.svg"
                                    alt="Cookie Table"
                                    className="my-6 w-[50%] sm:w-full"
                                    />
                                )}
                                </div>
                            ))
                            ) : (
                            art.content.split("\n").map((line, i) => (
                                <p key={i} className="font-lora text-black-600 text-[18px] mb-2">
                                {line.split(/(<link\s+[^>]+>)/g).map((part, k) => {
                                    const match = part.match(/<link\s+(.*?),\s*(https?:\/\/[^>]+)>/);
                                    if (match) {
                                    const text = match[1]
                                    const url = match[2]

                                    return (
                                        <a
                                        key={k}
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 underline"
                                        >
                                        {text}
                                        </a>
                                    );
                                    }
                                    return <React.Fragment key={k}>{part}</React.Fragment>;
                                })}
                                </p>
                            ))
                            )}
                        </div>
                        ))}

                      

                    </div>
                </div>
            </div>
        </>
    )
}